'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkPromoCard.module.css';

export function DevlinkPromoCard({
  as: _Component = _Builtin.Block,
  showImageSource = true,
  imageSource = '',
  title = 'Become a member and save up to $100 on your next service!',
  buttonSlot,
}) {
  return (
    <_Component className={_utils.cx(_styles, 'ht-promo-card')} tag="div">
      <_Builtin.Block className={_utils.cx(_styles, 'ht-promo-card-content')} tag="div">
        <_Builtin.Block className={_utils.cx(_styles, 'ht-promo-card-img')} tag="div">
          {showImageSource ? (
            <_Builtin.Image className={_utils.cx(_styles, 'ht-inner-img')} loading="lazy" width="auto" height="auto" alt="" src={imageSource} />
          ) : null}
        </_Builtin.Block>
        <_Builtin.Heading className={_utils.cx(_styles, 'txt-header-sm')} tag="h4">
          {title}
        </_Builtin.Heading>
      </_Builtin.Block>
      <_Builtin.Block className={_utils.cx(_styles, 'ht-button-group', 'fill-mobile')} tag="div">
        {buttonSlot}
      </_Builtin.Block>
    </_Component>
  );
}
